var map = {
	"./blocked.svg": "fc64",
	"./browser.svg": "9dca",
	"./camera.svg": "24e5",
	"./construction.svg": "ff88",
	"./data_flow.svg": "3dbe",
	"./draw line.svg": "1067",
	"./draw_area.svg": "9198",
	"./legenda.svg": "ba7d",
	"./map.svg": "0443",
	"./measure.svg": "c498",
	"./menu_button.svg": "1fa1",
	"./pause.svg": "644b",
	"./photo.svg": "7e86",
	"./play.svg": "dab1",
	"./point_of.svg": "6257",
	"./project_info.svg": "6a81",
	"./record.svg": "161c",
	"./spinner.svg": "1461",
	"./start_capture.svg": "6006",
	"./stop.svg": "56b4",
	"./stop_capture.svg": "7d31",
	"./stop_here.svg": "0b5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";